import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles = () => css`
  label: services-badge;

  width: 100%;
  height: auto;

  & > svg {
    display: block;
  }
`

export const ServicesBadge = styled('div')(baseStyles)
